import {Reducer} from 'redux'
import {PositionsActionTypes, PositionsState} from './types';
import PositionsService from "../../services/PositionsService";

// Type-safe initialState!
const initialState: PositionsState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<PositionsState> = (state = initialState, action) => {
	switch (action.type) {
		case PositionsActionTypes.FETCH_ALL_REQUEST: {
			PositionsService.getAll()
			return { ...state, loading: true }
		}
		case PositionsActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case PositionsActionTypes.FETCH_ONE_REQUEST: {
			PositionsService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case PositionsActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case PositionsActionTypes.SAVE_REQUEST: {
			PositionsService.save(action.payload)
			return { ...state, loading: true }
		}
		case PositionsActionTypes.SAVE_COMPLETED: {
			return { ...state, loading: false}
		}
		case PositionsActionTypes.DELETE_REQUEST: {
			PositionsService.delete(action.payload)
			return { ...state, loading: true }
		}
		case PositionsActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case PositionsActionTypes.DELETE_MULTIPLE_REQUEST: {
			PositionsService.deleteMultiple(action.payload)
			return { ...state, loading: true }
		}
		case PositionsActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as PositionsReducer}
